import loadable from "@loadable/component";

// Use dynamic imports with loadable to create loadable versions of components

// export { default as CreateButton } from "./CreateButton/index";
// export { default as ActionButton } from "./ActionButton/index";
// export { default as FilterButton } from "./FilterButton/index";
// export { default as CsvExport } from "./CsvExport/index";
// export { default as CommonButton } from "./Common/index.btn";
// export { default as GradientButton } from "./GradientButton/index.btn";
// export { default as CancelButton } from "./CancelButton/index.btn";

export const CreateButton = loadable(() => import("./CreateButton/index"));
export const ActionButton = loadable(() => import("./ActionButton/index"));
export const FilterButton = loadable(() => import("./FilterButton/index"));
export const CsvExport = loadable(() => import("./CsvExport/index"));
export const CommonButton = loadable(() => import("./Common/index.btn"));
export const GradientButton = loadable(() =>
  import("./GradientButton/index.btn")
);
export const CancelButton = loadable(() => import("./CancelButton/index.btn"));

/**
 * Lazy-loaded components using @loadable/component for better code splitting and performance.
 * This technique helps in reducing the initial bundle size by loading components only when needed.
 * Each exported constant corresponds to a lazily-loaded component.
 * Make sure to handle loading and error states appropriately in the parent components.
 */